import type { AxiosInstance } from 'axios';
import type { PlaceholderCatalogEntry } from '../types/template';

/**
 * Org-scoped curated placeholder catalog. Backend table: `placeholder_catalog`.
 * Endpoint: `GET /api/contract-service/api/v1/placeholder-catalog`.
 *
 * Session-authed only — no specific permission gate by BE design (the wizard
 * needs the catalog regardless of template-write capability).
 *
 * Lives on its own factory rather than `templateService` because the catalog
 * is not template-scoped: no `templateId`, no template lifecycle. Future
 * non-template consumers (signing-request wizard Step 3, snapshot admin,
 * cross-org snapshots) consume the same factory without coupling through
 * `templateService`.
 */
export function createPlaceholderCatalogService(client: AxiosInstance) {
  return {
    list: () =>
      client
        .get<PlaceholderCatalogEntry[]>('/v1/placeholder-catalog')
        .then((r) => r.data),
  };
}
